.container {
  padding: 0;

  select {
    margin: 0 0 10px;

    &:disabled {
      opacity: 0.5;
    }
  }
}
